export default class Locale_ThemeContainer {
	NameValidation : string = "Name is required and cannot be 'Default'";
}